// import BouncySlimeLottie from "@/assets/lotties/bouncy-slime.json";
import ScrollUpLottie from "@/assets/lotties/scroll-up.json";
import type { LottieRefCurrentProps } from "lottie-react";
import dynamic from "next/dynamic";
import { useRef } from "react";

// lottie-web (pulled in by lottie-react) references `document` at module
// load, crashing during SSR. Load client-side only.
const Lottie = dynamic(() => import("lottie-react"), { ssr: false }) as any;

const ScrollUpArrow = () => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleMouseOver = () => {
    lottieRef.current?.setDirection(1);
    lottieRef.current?.play();
  };

  const handleMosueLeave = () => {
    lottieRef.current?.setDirection(-1);
    lottieRef.current?.play();
  };

  return (
    <div
      className="cursor-pointer"
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMosueLeave}
    >
      <Lottie
        lottieRef={lottieRef}
        style={{
          width: "64px",
          height: "64px",
        }}
        loop={false}
        autoplay={false}
        animationData={ScrollUpLottie}
        onClick={handleClick}
      />
    </div>
  );
};

export default ScrollUpArrow;
